import * as z from "zod/v4";

export const getReturnWmsEvents = {
  name: "getReturnWmsEvents" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    events: z.array(
      z.object({
        id: z.string(),
        createdAt: z.string(),
        returnsCenterName: z.string().nullable(),
      }),
    ),
  }),
};
